import { render } from "./activityPage.vue?vue&type=template&id=cf0bb510"
import script from "./activityPage.vue?vue&type=script&lang=js"
export * from "./activityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__